import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  const url = config.url || "";
  const isAdminPath = url.startsWith("/admin") || url.startsWith("/auth/login") || url.startsWith("/auth/me");
  const token = localStorage.getItem(isAdminPath ? "lk_admin_token" : "lk_customer_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const errMsg = (e) => {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (detail?.message) return detail.message;
  if (detail?.msg) return detail.msg;
  return e?.message || "Something went wrong. Please try again.";
};
